module.exports = __webpack_public_path__ + "assets/img/22_282_big.bd5389ac.jpg";